import React, { createContext, useContext, useState, useEffect } from 'react';

const API = process.env.REACT_APP_API_URL || 'https://nico-548x.onrender.com/api';
const Ctx = createContext({});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Try to refresh token if main token fails
  const tryRefresh = async () => {
    const refresh = localStorage.getItem('nico_refresh');
    if (!refresh) return false;
    try {
      const r = await fetch(`${API}/auth/refresh`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ refreshToken: refresh }),
      });
      if (!r.ok) return false;
      const d = await r.json();
      localStorage.setItem('nico_token', d.token);
      return true;
    } catch { return false; }
  };

  useEffect(() => {
    const token = localStorage.getItem('nico_token');
    if (!token) { setLoading(false); return; }
    const ctrl = new AbortController();
    setTimeout(() => ctrl.abort(), 8000);
    fetch(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` }, signal: ctrl.signal })
      .then(r => {
        if (r.ok) return r.json();
        // Token expired? Try refresh
        return tryRefresh().then(ok => {
          if (!ok) throw new Error('expired');
          const newToken = localStorage.getItem('nico_token');
          return fetch(`${API}/auth/me`, { headers: { Authorization: `Bearer ${newToken}` } }).then(r2 => r2.ok ? r2.json() : Promise.reject());
        });
      })
      .then(d => setUser(d.user))
      .catch(() => { localStorage.removeItem('nico_token'); localStorage.removeItem('nico_refresh'); })
      .finally(() => setLoading(false));
    return () => ctrl.abort();
  }, []);

  const login = async (email, password) => {
    const r = await fetch(`${API}/auth/login`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });
    const d = await r.json();
    if (!r.ok) { const err = new Error(d.error || 'Erro'); err.data = d; throw err; }
    localStorage.setItem('nico_token', d.token);
    if (d.refreshToken) localStorage.setItem('nico_refresh', d.refreshToken);
    setUser(d.user);
    return d;
  };

  const register = async (name, email, password, role = 'owner', phone, business_name) => {
    const r = await fetch(`${API}/auth/register`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, email, password, role, phone, business_name }),
    });
    const d = await r.json();
    if (!r.ok) { const err = new Error(d.error || 'Erro'); err.data = d; throw err; }
    localStorage.setItem('nico_token', d.token);
    if (d.refreshToken) localStorage.setItem('nico_refresh', d.refreshToken);
    setUser(d.user);
    return d;
  };

  const logout = () => {
    localStorage.removeItem('nico_token');
    localStorage.removeItem('nico_refresh');
    setUser(null);
  };

  return <Ctx.Provider value={{ user, setUser, loading, isAuthenticated: !!user, login, register, logout }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
